import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserCardRequestFormData } from '../../../../forms/user-card-request-detail-form/user-card-request-detail-form.component';

@Component({
    selector: 'app-step-card',
    templateUrl: './step-card.component.html',
    styleUrls: ['./step-card.component.scss'],
})
export class StepCardComponent {
    @Input() data: UserCardRequestFormData;
}
